import { render, staticRenderFns } from "./AnnuaireFileDetails.vue?vue&type=template&id=05b4f27b&"
import script from "./AnnuaireFileDetails.vue?vue&type=script&lang=js&"
export * from "./AnnuaireFileDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05b4f27b')) {
      api.createRecord('05b4f27b', component.options)
    } else {
      api.reload('05b4f27b', component.options)
    }
    module.hot.accept("./AnnuaireFileDetails.vue?vue&type=template&id=05b4f27b&", function () {
      api.rerender('05b4f27b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/annuaire/AnnuaireFileDetails.vue"
export default component.exports